module.exports = __webpack_public_path__ + "img/sleeping.5e128d43.png";